export default "__VITE_ASSET__C7zS428W__"